import medicitokyoSrc from "assets/images/open-call-medicitokyo.jpg";
import shirt from "assets/images/randi-shirt.jpg";
import metaqueensSrc from "assets/images/metaqueens.png";
import seamless1 from "assets/images/seamless_image1.png";
import seamless2 from "assets/images/seamless_image2.png";
import blackmirrordigitalexperience1 from "assets/images/blackmirrordigitalexperience-1.jpg";
import blackmirrordigitalexperience2 from "assets/images/blackmirrordigitalexperience-2.png";

type KeyValuePair = { [key: string]: string };

const customDescriptions: KeyValuePair = {
  medicitokyo: `
  <p>
    HUG is excited to be teaming up with Cozomo de’ Medici to showcase 6 artists
    and their artworks alongside iconic pieces from The Medici Collection on the
    digital billboards at the Shibuya Crossing in Tokyo.
  </p>
  <p><br /></p>
  <img src="${medicitokyoSrc}" alt="Example images for Medici Tokyo open call"/>
  <p><br /></p>
  <p>
    Shibuya Crossing is the world’s busiest pedestrian crossing, and averages 2.5
    million people each day.
  </p>
  <p><br /></p>
  <p>
    Cozomo de’ Medici will be looking for and personally selecting 6 pieces of
    artwork that will be displayed along the following pieces from The Medici
    Collection:
  </p>
  <p style="margin-top: 10px">• <a href="https://go.thehug.xyz/xcopy" target="_blank"><em>Right-Click and Save As Guy</em></a> by XCOPY</p>
  <p>• <a href="https://go.thehug.xyz/beeple" target="_blank"><em>START AGAIN</em></a> by Beeple</p>
  <p>• <a href="https://go.thehug.xyz/clairesilver" target="_blank"><em>the fisher king</em></a> by Claire Silver</p>
  <p>• <a href="https://go.thehug.xyz/grantyun" target="_blank"><em>Life in America</em></a> by Grant Yun</p>
  <p>• <a href="https://go.thehug.xyz/samspratt" target="_blank"><em>I. Birth of Luci</em></a> by Sam Spratt</p>
  <p>• <a href="https://go.thehug.xyz/dawniadarkstone" target="_blank"><em>LetsFixIt</em></a> by Dawnia Darkstone</p>
  <p><br /></p>
  <p>
    Community voting, which will be open to the public for the first time from Sep
    25-27, will help shortlist the top 50 artworks for Cozomo to select from.
  </p>
  <p><br /></p>
  <p>
    You are welcome to submit any artwork of your choice, but pieces that are
    inspired by, or serve as companion works to any of the above 6 artworks will
    likely have a higher chance of getting curated.
  </p>
  `,
  metaqueens: `
  <p>
    Meta Queens is launching a collection to empower and uplift the voices of queer & trans
    creators & artists in the digital space,
    and they <strong>would love to co-create with you!
  </strong></p>
  <p><br /></p>
  <p>
    5 Meta Queens for the generative collection have been created by their
    artist Emilia Weryńska and they are looking for artists
    to <strong>create the backdrop for each.</strong></p>
  <p><br /></p>
  <img src="${metaqueensSrc}" width="250" alt="Picture 5 Meta Queens for the generative collection"/>
  <p><br /></p>
  <p>5 artists and their background designs will be selected and paid <strong>$500 USD each</strong> for their creation and contribution to the Meta Queens NFT Collection.</p>
  <p><br /></p>
  <p><strong>About Meta Queens</strong></p>
  <p>Meta Queens' mission is to empower and uplift the voices of queer & trans creators & artists in the digital space. They strive to inspire, educate, and entertain while building a digital haven where everyone can feel seen, heard, celebrated and protected. Meta Queens will give back to the LGBTQIA+ community, fund queer charities, and uplift queer creators in the Web3 Space.</p>
  `,
  seamlesspatterns: `
  <p>
    <strong>
      As an extension to the HUG Print Shop, HUG is adding a limited edition collection of products for
      the holidays. Artists will be able to sell their work on festive items like wrapping paper,
      greeting cards, notebooks, and more.
    </strong>
  </p>
  <p><br></p>
  <p>
    For our launch, we are looking for a variety of seamless patterns that can be
    applied… you guessed it, <em>seamlessly</em>, across popular gift items like
    wrapping paper, greeting cards, and notebooks.
  </p>
  <p><br></p>
  <img src="${seamless1}" alt="Example images seamless patterns open call"/>
  <img src="${seamless2}" alt="Example images seamless patterns open call"/>
  <p><br></p>
  <p><strong>Selling through the HUG Holiday Shop</strong></p>
  <p><br></p>
  <p>
    To make art collecting accessible, pricing will be the same for all participating
    artists. Depending on the product, pricing varies from around $15 to $60.
  </p>
  <p><br></p>
  <p>
    HUG will be responsible for all production, shipping, and all other logistics.
  </p>
  <p><br></p>
  <p>
    Selected Artists will receive 20% of sales, and will agree to grant HUG a worldwide,
    non-exclusive, royalty-free, revocable license to reproduce, sell and distribute
    their artworks.
  </p>
  <p><br></p>
  <p>
    Artists can also opt to sell their seamless pattern as a digital collectible in
    exchange for an Artist Tip of $5, $7, or $10 from the buyer. 100% of net
    proceeds from digital collectible sales will go towards the artist.
  </p>
  <p><br></p>
  <p>
    <em>Questions about the HUG Holiday Shop?</em> Email hello@thehug.xyz. </p>
  <p><br></p>
  <p><em>Art credit: Sylvie Lee Vo of studio SYLVO</em></p>
  <p><a href="https://thehug.xyz/artists/sylvo">thehug.xyz/artists/sylvo</a></p>
  `,
  blackmirrordigitalexperience: `
  <p>This open call is for artists to contribute Black Mirror-inspired pieces to a rewards pool for the digital experience. Artists of all levels may apply and 20 selected artists will receive a press highlight, social support, and a free pass to the experience.</p>
  <p><br></p>
  <p>Black Mirror Digital Experience (Part 1) is based on Season 3, Episode 1: Nosedive. Please consider this with any artwork submissions, as we are looking for themed pieces that live in the Black Mirror Universe.</p>
  <p><br></p>
  <img src="${blackmirrordigitalexperience1}" alt="Example images black mirror open call"/>
  <p><br></p>
  <img src="${blackmirrordigitalexperience2}" alt="Example images black mirror open call"/>
  <p><br></p>
  <p>This is for digital use only, and will not be used outside of the experience apart from sharing on socials.</p>
  <p><br></p>
  <p>Users who can claim these digital arts rewards will be able to see the credited artist and we can include social links to the artists as well.</p>
  <p><br></p>
  <p>This Black Mirror Digital Experience is 4 weeks of challenges, quests, quizzes etc, themed around Nosedive. The experience itself is called 'Smile Club'. All corresponding branding, key art, etc can be found on our socials (@blackmirror_xp).</p>
  <p><br></p>
  <p>Artwork cannot contain any actors names or likeness - so get creative! We can't wait to see your vision of Black Mirror and Nosedive come to life for this experience.  </p>
  `,
};

const customRequirements: KeyValuePair = {
  runlikeamother: `
  <p><strong>Guidelines:</strong></p>
  <p>- "Run Like A Mother" inspired jersey front design: 12" x 14"</p>
  <p>- File Requirements: <strong>.JPG</strong> or <strong>.PNG</strong> only</p>
  <p>- A maximum of <strong>8 colors</strong> can be used in your design.</p>
  <p>- The marathon jersey will be <strong>black</strong>, so please consider this when choosing the color palette for your design submission.</p>
  <p>- Vector, Large Specs, and High-Res files work best!</p>
  <p><br></p>
  <p>Below is a reference image of the jersey and the artwork border:</p>
  <img src="${shirt}" width="250" height="344" alt="Picture of Randi’s running shirt showing the artworks bounding box"/>
  <p>You can test your submission file using the <a href="https://www.rushordertees.com/catalog/sport-tek/womens-endeavor-tank/?color=d531" target="_blank">Rush Order Tees design tool</a>.</p>
  <p><br></p>
  <p>Please ensure that all submissions are available via a transparent layer so we can add the design to the jersey if selected. If time permits, the grand prize winner will also have the option of creating a back design for Randi's jersey.</p>
  <p><br></p>
  <p>The HUG community will come together in community-led curation to shortlist 25 submissions with the Mother Hugger, Randi Zuckerberg, selecting the 3 winning designs.</p>
  <p><br></p>
  <p><strong><em>Artwork must be family-friendly to be considered eligible for consideration. </em></strong><em>Artwork depicting violence, nudity, obscene, or grotesque imagery are all strictly prohibited.</em></p>
  `,
};

export { customDescriptions, customRequirements };
